// Dictionary-like lore snippets for tooltips.
//
// IMPORTANT:
// - Keep these entries short (tooltip-scale).
// - Long-form lore belongs in the Grimoire (or markdown files), not here.

const loreData = {
  umbral_reavers: {
    title: 'Umbral Reavers',
    body: 'A shadow guild dedicated to hunting monstrosities that breach the realm from the Grey Lament.',
  },
  grey_lament: {
    title: 'Grey Lament',
    body: 'A fragile boundary holding back the Void. Where it thins, reality unravels and things cross over.',
  },
  bone_key: {
    title: 'Bone Key',
    body: 'A jagged key recovered from Arathus. Its purpose is unknown.',
  },
  house_thane: {
    title: 'House Thane',
    body: 'Favored stewards of the Saint-King—owners of the realm’s logistics, roads, and enforcement.',
  },
};

export default loreData;
